<template>
  <span :class="{ 'red--text': value < 0 }">{{ value | decimal }}</span>
</template>

<script>
export default {
  props: ["value"],
};
</script>
